<app-modal
  title="Acesso ao Control Pass (Totem)"
  [form]="form"
  (save)="onSave($event)"
>
  <form [formGroup]="form">
    <div class="tds-row">
      <div class="tds-u-mb3">
        <p class="tds-body-01">
          Por favor, defina o local para inicializar o totem.
        </p>
      </div>

      <app-select
        label="Local *"
        [options]="data.localList"
        formControlName="local"
      ></app-select>
    </div>
  </form>
</app-modal>
